<template>
  <div>
    <div v-if="separator" class="separator"></div>
    <div
      class="tree-row"
      :style="
        `margin-left: ${nestedGrade * 3}%; background-color: ${
          zebra ? '#e0e0e0' : '#fafafa'
        };`
      "
      @click="clickRow"
    >
      <div class="container">
        <div style="width: 20px; height: 20px;">
          <i
            class="fa"
            :class="
              item.children
                ? `fa-chevron-${
                    collapses.includes(item.ruta) ? 'down' : 'right'
                  }`
                : 'fa-minus'
            "
          ></i>
        </div>

        <span class="font fontView">
          {{ item.concepto.toCapitalize() }}
        </span>
      </div>
      <span class="font right">
        {{ $formatter(item.getTotal(), item.moneda) }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "TreeRow",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    collapses: {
      type: Array,
      default: () => []
    },
    toggleCollapse: {
      type: Function,
      default: () => {}
    },
    zebra: {
      type: Boolean,
      default: false
    },
    separator: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    nestedGrade() {
      const item = this.item;
      return item.ruta ? item.ruta.split("/").length - 1 : 0;
    }
  },
  methods: {
    clickRow() {
      this.item.children ? this.toggleCollapse(this.item.ruta) : null;
    }
  }
};
</script>

<style lang="scss" scoped>
.tree-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  border-radius: 8px;
  margin-bottom: 0px;
  margin-top: 0px;

  //marginLeft: `${nestedGrade * 3}%`;
  //backgroundColor: zebra ? '#e0e0e0' : '#fafafa';
}
.container {
  display: flex;
  flex: 1;
  //flex-direction: row;
  align-items: center;
}
.fontView {
  flex: 1;
  display: flex;
}
.font {
  font-weight: bold;
  font-size: 25px;
  font-size: 22px;
  display: flex;
  margin-right: 5px;
}
.right {
  text-align: right;
}
.separator {
  height: 2px;
  margin-top: 2px;
  margin-bottom: 2px;
}
</style>
